import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { ShoppingBag, Wallet, Smartphone, Users, User, Sun, Moon, Wallet2, LogOut } from "lucide-react";
import api, { fmtTL } from "@/lib/api";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";

const TABS = [
  { to: "/panel/satin-al", label: "Satın Al", Icon: ShoppingBag, tid: "tab-buy" },
  { to: "/panel/cuzdan", label: "Cüzdan", Icon: Wallet, tid: "tab-wallet" },
  { to: "/panel/numaralarim", label: "Numaralarım", Icon: Smartphone, tid: "tab-numbers" },
  { to: "/panel/ortaklik", label: "Ortaklık", Icon: Users, tid: "tab-affiliate" },
  { to: "/panel/profil", label: "Profil", Icon: User, tid: "tab-profile" },
];

export default function PanelLayout() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const nav = useNavigate();
  const [balance, setBalance] = useState(user?.balance ?? 0);

  useEffect(() => {
    if (user === false) nav("/giris");
  }, [user, nav]);

  useEffect(() => {
    const load = () => api.get("/wallet").then(({ data }) => setBalance(data.balance)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    const h = () => load();
    window.addEventListener("wallet-refresh", h);
    return () => { clearInterval(t); window.removeEventListener("wallet-refresh", h); };
  }, []);

  if (!user) return <div className="min-h-screen bg-panel-bg grid place-items-center text-panel-secondary">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-panel-bg text-panel-text flex flex-col">
      {/* header */}
      <header className="sticky top-0 z-40 bg-panel-header border-b border-panel-border">
        <div className="mx-auto max-w-3xl px-4 h-16 flex items-center justify-between">
          <Link to="/"><Logo size="sm" /></Link>
          <div className="flex items-center gap-2">
            <button onClick={toggle} data-testid="panel-theme-toggle" className="h-10 w-10 grid place-items-center rounded-xl card">
              {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
            </button>
            <button onClick={() => nav("/panel/cuzdan")} data-testid="panel-balance-pill" className="btn-blue rounded-full h-10 px-4 flex items-center gap-2 font-semibold text-sm">
              <Wallet2 size={16} /> {fmtTL(balance)}
            </button>
            {user.role === "admin" && (
              <button onClick={() => nav("/adc")} className="hidden sm:block rounded-xl card h-10 px-3 text-xs font-semibold">Admin</button>
            )}
            <button onClick={() => { logout(); nav("/"); }} data-testid="panel-logout" className="h-10 w-10 grid place-items-center rounded-xl card"><LogOut size={16} /></button>
          </div>
        </div>
      </header>

      {/* content */}
      <main className="flex-1 mx-auto max-w-3xl w-full px-4 pt-5 pb-28">
        <Outlet />
      </main>

      {/* bottom tabs */}
      <nav className="fixed bottom-0 inset-x-0 z-40 bg-panel-nav border-t border-panel-border">
        <div className="mx-auto max-w-3xl grid grid-cols-5">
          {TABS.map(({ to, label, Icon, tid }) => (
            <NavLink key={to} to={to} data-testid={tid}
              className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${isActive ? "text-brand-500" : "text-panel-muted"}`}>
              {({ isActive }) => (<><Icon size={21} strokeWidth={isActive ? 2.4 : 2} /><span>{label}</span></>)}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
